import React,{useState,useEffect,useRef} from 'react'
import data from '../../../constant/data.json'
import AppNextButton from '../../../components/elements/NextButton'
import { getInterPolateValue } from '../../../utils/helper';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
export default function ContactSection({notHomePage}) {
    const [axisY,setPosition] = useState(0);
    const [selectedItem,setSelectedItem] = useState(0);
    const handleScroll = () => {
        const position = window.pageYOffset;
        setPosition(position); //start 8163 end 8550 
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (
        <div className='contact-main'>
            <div className='conatc-line-1' />
            <div style={{display:"flex",height:716}}>
                <div className='contact-side-1'>
                    <p className='contact-text-1'>Let's <br />work<br /> together</p>
                    <p className='contact-text-2'>{data.email} <br />{data.call}<br />{data.place}</p>
                    <img
                    
                    style={{
                        left:notHomePage? 100:getInterPolateValue(axisY,8163,8950,0,100,true),
                        rotate:"270deg",
                        transform: notHomePage?"rotate(90deg)" :`rotate(${getInterPolateValue(axisY,8163,8950,0,90,true)}deg)`
                        // transform:
                        // rotate:`${getInterPolateValue(axisY,1450,1927,-90,0,true)}deg`
                    }}
                    
                    src={require("../../../assets/images/ahsafdp.png")} className='contact-dp-img' />
                </div>
                <div className='conatc-line-2' />
                <div className='contact-side-2'>
                    <p className='contact-text-3'>What CAN I OFFer</p>
                
          <Carousel 
                 autoPlay={false}
                 selectedItem={selectedItem}
                 infiniteLoop
                 showArrows={false}
                 showStatus={false}
                 showIndicators={false}
                 showThumbs={false}
                 width={window.innerWidth/2}
                 className='carosel-main'
                 >
                      <p className='contact-text-4'>REACT NATIVE<br /> DEVELOPMENT</p>
                      <p className='contact-text-4'>FLUTTER<br /> DEVELOPMENT</p>
                      <p className='contact-text-4'>REACT JS<br /> DEVELOPMENT</p>
                      <p className='contact-text-4'>NODE JS<br /> DEVELOPMENT</p>
               
            </Carousel>
                
                    <div style={{display:"flex",justifyContent:'space-between',marginBottom:100,paddingLeft:100,paddingRight:100}}>
                        <AppNextButton onClick={()=>{
                            setSelectedItem(selectedItem > 0?selectedItem - 1:0);
                        }} isLeft />
                        <AppNextButton onClick={()=>{
                            setSelectedItem(selectedItem === 3?3: selectedItem + 1);
                        }} />
                    </div>
                </div>
            </div>
            <div className='conatc-line-1' />
        </div>
    )
}
